<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <!-- <div class="part-one-content"></div> -->
                </div>
            </div>
            <div style="position: relative; top: -3.7rem">
                <div class="desc-box">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div>按照成都市体育局、成都市财政局、成都市人力资源和社会保障局《关于印发<成都市竞技体育人才培育经费保障办法（2020修订）>
                            的通知》（成体发〔2020〕11号）文件中相关条款落实大型综合性运动会竞赛成绩奖励。</div>
                </div>
                <!-- <div class="zccl">
                    <img class="top" src="./../assets/imgs/127/part-1-title.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）竞技体育人才培养经费包括成都市竞技体育人才培养项目经费、奖励经费和退役补助经费。
                        </div>
                        <div class="des">
                            （二）竞技体育人才培养项目经费是指我市培养各类体育项目业余运动员和优秀运动员的经费。成都竞技体育人才培养项目包括市体育局确定的重点发展体育项目和培养提升体育项目。
                            <div style="margin-top:0.1rem">
                                1．重点发展体育项目是指我市具有传统优势的竞技体育项目，包括:体操、艺术体操、乒乓球、射击、网球、游泳、花样游泳、跳水、田径、羽毛球、武术、足球（五人制足球)、篮球(三人篮球)、排球（沙滩排球)、棋类（围棋、象棋、国际象棋、国际跳棋、五子棋）等。
                            </div>
                            <div style="margin-top:0.1rem">
                                2．培养提升体育项目是指我市新兴发展的竞技体育项目，包括:速度轮滑、赛艇、皮划艇、冰球（轮滑冰球)、冰壶、花样滑冰、滑雪、水球、击剑、马术、电子竞技、曲棍球、垒球、棒球、自行车、举重、柔道、跆拳道、射箭、模型、无线电测向、定向越野、铁人三项等。
                            </div>
                        </div>
                        <div class="des">
                            （三）第七条奖励经费是指对训练单位和教练员引进输送具有发展潜力或有较高竞技水平运动员的资金奖励以及对运动员、教练员、工作人员及训练单位参加各级各类比赛获得较好成绩的资金奖励。
                            <div class="innerTiTle">成都市可奖励的各级各类赛事包括：</div>
                            <div class="innerCircle innerTiTle">
                                <div class="innerCircle-circle">1</div>
                                年度单项竞赛
                            </div>
                            <div class="innerCont">
                                <div>1．省级比赛:四川省青少年锦标赛。</div>
                                <div>2．全国比赛:列入国家单项运动协会竞赛计划并经市体育局认可的比赛。</div>
                                <div>3．国际比赛:世界锦标赛、世界杯总决赛、世界杯分站赛、世界青少年锦标赛、亚洲锦标赛、亚洲杯、亚洲青少年锦标赛。</div>
                            </div>
                            <div class="innerCircle innerTiTle">
                                <div class="innerCircle-circle">2</div>
                                综合性运动会
                            </div>
                            <div class="innerCont">
                                <div>1．省级比赛:四川省运动会、四川省智力运动会。</div>
                                <div>2．全国比赛:全国运动会、全国青年运动会、全国智力运动会。</div>
                                <div>3．国际比赛:奥林匹克运动会、青年奥林匹克运动会、亚洲运动会。</div>
                            </div>
                        </div>
                        <div class="des">
                            （三）退役补助经费是指优秀运动员经市体育局批准退役，一次性发给的退役经济补偿，具体金额根据优秀运动员参加运动队的年限、本人退役前的工资待遇和取得的成绩计算确定。
                        </div>
                    </div>
                </div> -->
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/127/title-1.png" alt="" />
                    <div class="content" style="font-size: 0.3rem;font-weight: bolder;">
                        参加经市体育局认可的大型综合性运动会的运动员、教练员及相关人员和单位。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/127/title-2.png" alt="" />
                    <div class="content" style="font-size: 0.3rem;font-weight: bolder;">
                        按一事一议原则，由市体育局参照省体育局和其他省(市)的奖励标准制定奖励方案，向市政府专报申请奖励。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/127/title-3.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61884357">028-61884357</a>
                                <!-- <span style="margin-left: 0.5rem;color: #1355FF;">范霁</span> -->
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市体育局青少年体育处
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <call phone="028-61884357"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "",
    data() {
        return {

        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .desc-box {
        width: 6.85rem;
        background: #fff;
        border-radius: 0.28rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 1.2rem;
        position: relative;
        color: #4E4E4E;
        font-size: 0.26rem;

        img {
            width: 6.85rem;
            height: 2.12rem;
            margin-top: -0.6rem;
        }

        div {
            padding: 0.36rem;
            line-height: 1.7;
            text-align: left;
        }
    }

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        min-height: 7.2rem;
        box-sizing: border-box;
        padding-bottom: 0.3rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            min-height: 5.84rem;
            background: url(../assets/imgs/127/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.2rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: -0.18rem;
                    width: 7.03rem;
                    height: 1.37rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.2rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 0.16rem;
        padding-left: 0.25rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;
            margin-bottom: 0.22rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-items {
            width: 6.35rem;
            padding-bottom: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.15rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.21rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.28rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-three-extra {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.15rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .circle-title {
            font-weight: bold;
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #333;
            margin-bottom: 0.5rem;
            margin-top: 0.2rem;

            .circle {
                width: 0.22rem;
                height: 0.22rem;
                border: 0.06rem solid #FF6D60;
                border-radius: 50%;
                margin-right: 0.05rem;
            }
        }

        .main-content {
            margin-top: 0.8rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;
            position: relative;
            // margin-bottom: 0.8rem;

            .part-four-title {
                text-align: left;
                position: absolute;
                top: 0;
                left: 50%;
                width: 2.98rem;
                font-size: 0.32rem;
                background-color: #739bfeff;
                color: #fff;
                border-radius: 20px;
                text-align: center;
                padding: 0.18rem 0.2rem;
                transform: translate(-50%, -50%);
                white-space: nowrap;
            }

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;

                &>p {
                    display: flex;
                    align-items: center;
                    font-size: 0.26rem;
                    color: #4E4E4E;
                    font-weight: bold;
                    margin-top: 0.3rem;

                    img {
                        width: 0.39rem;
                        height: 0.39rem;
                        margin-right: 0.14rem;
                    }
                }
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.2rem 0.25rem 0.35rem 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.9rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .extendFont {
                    min-width: 7rem;
                    position: absolute;
                    top: 50%;
                    left: 0.58rem;
                    transform: translateY(-50%);
                }

                .title-bg3 {
                    width: 5rem;
                    height: 0.6rem;
                    background: url(../assets/imgs/Relocationallowance/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/121/part5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/121/part6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .sxcl {
        position: relative;
        margin-top: 0.22rem;

        .top {
            width: 7.03rem;
            height: 1.37rem;
            margin-left: -0.18rem;
        }

        .content {
            width: 6.85rem;
            background: #fff;
            margin: -0.45rem auto 0;
            padding: 0.54rem;
            box-sizing: border-box;
            border-radius: 0rem 0rem 0.26rem 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem !important;
            font-weight: 500 !important;
            text-align: left;
            color: #4e4e4e;
            line-height: 0.44rem;
        }
    }

    .zccl {
        position: relative;
        margin-top: 0.22rem;
        font-size: 0.26rem;

        .top {
            width: 7.03rem;
            height: 1.37rem;
            margin-left: -0.18rem;
        }

        .content {
            width: 6.85rem;
            background: #E8EEFF;
            margin: -0.45rem auto 0;
            padding: 0.33rem;
            box-sizing: border-box;
            border-radius: 0rem 0rem 0.26rem 0.26rem;
            padding-top: 0.28rem;

            font-weight: 500;
            text-align: left;
            color: #4e4e4e;

            .des {
                color: #4e4e4e;
                text-align: left;
                background: #ffffff;
                border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                padding: 0.35rem 0.23rem 0.3rem;
                margin-top: 0.2rem;
                position: relative;
                text-align: left;
                line-height: 0.44rem;

                color: #4E4E4E;
                font-size: 0.26rem;
                font-weight: normal;

                .title {
                    font-weight: bold;
                    position: absolute;
                    top: -0.6rem;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    // height: 0.67rem;
                    font-size: 0.3rem;

                    // border: 1px solid red;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .circle {
                        width: 0.22rem;
                        height: 0.22rem;
                        border: 0.06rem solid #FF6D60;
                        border-radius: 50%;
                    }
                }

                .innerTiTle {
                    color: #4E4E4E;
                    font-weight: bold;
                    font-size: 0.24rem;
                }

                .innerCont {
                    padding-left: 0.5rem;
                }

                .innerCircle {
                    height: 0.37rem;
                    display: flex;
                    align-items: center;
                    margin: 0.08rem 0;

                    &-circle {
                        border-radius: 50%;
                        height: 0.36rem;
                        width: 0.36rem;
                        background: #739BFE;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        margin-right: 0.13rem;
                    }
                }
            }
        }
    }

}</style>
